export class SubCategoryAddModel {
    id: number;
    categoryId:any;
    name: any = null;
    status: boolean;    
}
